import React, { Suspense, lazy } from "react";
import "./App.css";
import NavBar from "./Components/NavBar/NavBar";
import FooterWithLinks from "./Components/Footer/Footer";
import Home from "./Components/Home/Home";
import NoMatch from "./Components/Pages/Error404";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { themeChange } from "theme-change";
import { useEffect } from "react";
import Projects from "./Components/Pages/Projects";

const About = lazy(() => import("./Components/Pages/About"));
const Matching = lazy(() => import("./Components/Pages/Matching"));
const You = lazy(() => import("./Components/Pages/You"));

const App = () => {
  useEffect(() => {
    themeChange(false);
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <NavBar />

        <Routes>
          <Route path="*" element={<NoMatch />} />
          <Route path="/" element={<Home />} />
          <Route
            path="/matching"
            element={
              <Suspense fallback={<h1>"Loading..."</h1>}>
                <Matching />
              </Suspense>
            }
          />
          <Route path="/calculator" element={<Projects />} />
          <Route
            path="/About"
            element={
              <Suspense fallback={<h1>"Loading..."</h1>}>
                <About />
              </Suspense>
            }
          />
          <Route
            path="/e-commerce"
            element={
              <Suspense fallback={<h1>"Loading..."</h1>}>
                <You />
              </Suspense>
            }
          />
        </Routes>

        <FooterWithLinks />
      </BrowserRouter>
    </div>
  );
};

export default App;
